import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest,  HttpResponse,    HttpHandler,    HttpEvent,    HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Common } from '../Module/Shared/Utility/Common';

@Injectable()
export class HttpReqInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const token: string = localStorage.getItem('sales_token');
       // console.log("ptoken",token)
        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        }
       
       


        if (!request.headers.has('PC_FORM-Type')) {
            if (!request.headers.has('Content-Type')) {
                request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
            }
        }else{
            //console.log("PC_FORM-Type")
        }
        
        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) { 
                      //Common.log('event--->>>'+ event);
                }
                return event;
            }));
    }
}